import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Form } from 'antd';

import { useProduct, useBranches, useUpdateProduct } from '../../hooks';
import { removeObjectProperties } from '../../utils';
import { Card, FormActions, FormSkeleton, PageHeader } from '../../components';
import { ROUTE_URLS } from '../../routes';
import { useI18n } from '../../i18n';
import { ProductFields } from './ProductFields';

const stringId = id => `${id}`;

export const EditProduct = () => {
  const { id } = useParams();
  const { t } = useI18n();

  const { data: product, isLoading: isProductDataLoading } = useProduct(id);
  const { data: branches, isLoading: isLoadingBranches } = useBranches();
  const { mutateAsync: editProduct, isLoading } = useUpdateProduct(id);

  const defaultValues = useMemo(() => {
    const values = {};
    product?.branches.forEach(branch => {
      values[branch.id] = branch.sell_price;
    });
    return values;
  }, [product]);

  const createSellPricesArray = values => {
    const branchSellPrices = {};
    branches.forEach(branch => {
      branchSellPrices[branch.id] = values[branch.id];
    });
    return branchSellPrices;
  };

  const onFinish = values => {
    const readyValues = {
      status: 1,
      branch_ids: createSellPricesArray(values),
      ...removeObjectProperties(values, [
        'branchSearchValue',
        ...branches.map(branch => branch.id),
      ]),
    };
    editProduct({ ...readyValues, id });
  };

  return (
    <div className='wm-form-page'>
      <PageHeader
        backTo={ROUTE_URLS.PRODUCTS}
        backLabel={t('nav.products')}
        title={t('products.editTitle')}
        subtitle={product?.name ?? t('products.editSubtitle')}
      />
      {isProductDataLoading || isLoadingBranches ? (
        <Card>
          <FormSkeleton fields={5} />
        </Card>
      ) : (
        <Form
          name='createProducts'
          layout='vertical'
          onFinish={onFinish}
          requiredMark={false}
          initialValues={{
            ...product,
            ...defaultValues,
          }}
        >
          <ProductFields branches={Array.isArray(branches) ? branches : []} branchFieldName={stringId} />
          <FormActions cancelTo={ROUTE_URLS.PRODUCTS} submitting={isLoading} />
        </Form>
      )}
    </div>
  );
};
